<template>
    <div>
        <div class="refine__mobile--menu row">
            <div :class="{'mobile__refine--button': true, 'mobile__refine--selected': mobileRefineOpened}"
                 @click.prevent="mobileRefineToggle">
                <i class="fi-filter"></i>
                <span class="mob__refine-text"
                      v-html="mobileRefineOpened ? 'Close' : 'Refine'"></span>
            </div>
        </div>

        <div :class="{'mobile__refine': true, 'mobile__refine--hidden': !mobileRefineOpened}">
            <div class="clear mobile__refine--spacer"></div>

            <div class="mb-10" v-if="dealerName">
                <div class="refine__header mb-10">
                    Dealer stock for
                </div>
                <div class="refine__dealer-name">
                    <i class="fi-cancel text-red pointer" @click="removeDealerFilter"></i>
                    {{ dealerName }}
                </div>
            </div>

            <div class="row" v-if="cars === 'used'">
                <div class="col-12-sm">
                    <div class="refine__header mb-10">
                        New and used cars
                    </div>
                </div>
                <div class="col-6-md mb-10">
                    <div :class="{
                        'button': true,
                        'button--small': true,
                        'button--full': true,
                        'button--ghost': cars !== 'used'
                    }" @click="changeCarType('used')">
                        Used
                    </div>
                </div>
                <div class="col-6-md mb-10">
                    <a href="/leasing" :class="{
                        'button': true,
                        'button--small': true,
                        'button--full': true,
                        'button--ghost': cars === 'used'
                    }">
                        New
                    </a>
                </div>
            </div>


            <div class="refine__header mb-10">
                Make & Model
            </div>
            <multi-select
                    v-model="searchObject.makes"
                    name="make"
                    :options="searchOptions.makes"
                    placeholder="Preferred Manufacturers"
                    :loading="makesUpdating"
                    :searchable="true"
                    @change="changeMake"
            ></multi-select>
            <div class="multiMakeModels mb-10">
                <div class="refine__models--dd" v-for="make in searchObject.makes">
                    <div class="refine__header refine__header--models"
                         v-html="make.toUpperCase() + ' Models'"></div>
                    <div v-if="searchOptions.models[make] && searchOptions.models[make].length">
                        <multi-select
                                v-model="searchObject.models[make]"
                                :name="make+'models'"
                                :options="searchOptions.models[make]"
                                placeholder="Preferred Models"
                                :searchable="true"
                                @change="updateCount"
                        ></multi-select>
                    </div>
                    <div class="form__field form__field--dropdown" v-else>
                        <div class="loading" style="height: 40px;" >
                            <div class="buffer buffer--large buffer--rounded">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="refine__header">
                Bodystyle
            </div>
            <drop-down
                    v-model="searchObject.bodystyle"
                    name="bodystyle"
                    :options="searchOptions.bodystyle"
                    @change="updateCount"
            ></drop-down>


            <div class="row" v-if="cars === 'used'">
                <div class="col-6-md mb-10">
                    <div :class="{
                            'button': true,
                            'button--small': true,
                            'button--full': true,
                            'button--ghost': searchObject.pricetype !== 'cash'
                        }" @click="changePriceType('cash')">

                        Cash Price
                    </div>
                </div>
                <div class="col-6-md mb-10">
                    <div :class="{
                            'button': true,
                            'button--small': true,
                            'button--full': true,
                            'button--ghost': searchObject.pricetype !== 'finance'
                        }" @click="changePriceType('finance')">
                        Monthly Price
                    </div>
                </div>
            </div>


            <template v-if="['used', 'finance'].includes(cars) && searchObject.pricetype === 'cash'">
                <div class="row">
                    <div class="col-6-md">
                        <drop-down
                                v-model="searchObject.minprice"
                                name="minprice"
                                :options="searchOptions.price"
                                @change="updateCount"
                                label="Min Price"
                        ></drop-down>
                    </div>
                    <div class="col-6-md">
                        <drop-down
                                v-model="searchObject.maxprice"
                                name="maxprice"
                                :options="searchOptions.price"
                                @change="updateCount"
                                label="Max Price"
                        ></drop-down>
                    </div>
                    <div class="col-12-sm">
                        <div v-if="invalidPriceRange" class="alert">
                            Oops make sure you have a max price higher than the min price
                        </div>
                    </div>
                </div><!--suppress ALL -->
            </template>


            <template v-if="searchObject.pricetype === 'finance'">
                <div class="row">
                    <div class="col-6-md">
                        <drop-down
                                v-model="searchObject.minmonthly"
                                name="minmonthly"
                                :options="searchOptions.monthlyPrice"
                                @change="updateCount"
                                label="Min Monthly"
                        ></drop-down>
                    </div>
                    <div class="col-6-md">
                        <drop-down
                                v-model="searchObject.maxmonthly"
                                name="maxmonthly"
                                :options="searchOptions.monthlyPrice"
                                @change="updateCount"
                                label="Max Monthly"
                        ></drop-down>
                    </div>
                    <div class="col-12-sm">
                        <div v-if="invalidPriceRange" class="alert">
                            Oops make sure you have a max monthly price higher than the min monthly price
                        </div>
                    </div>
                </div>

            </template>

            <div class="row" v-if="cars === 'used'">
                <div class="col-12-sm">
                    <div class="refine__header">
                        Location
                    </div>
                    <div class="mt-10" v-if="searchObject.city || searchObject.region">
                        <div class="refine__dealer-name">
                            <i class="fi-cancel text-red pointer" @click="removeRegionFilter"></i>
                            {{ localFilterLabel }}
                        </div>
                    </div>
                </div>
                <div class="col-6-md pt-10">
                    <input-text
                            input-type="text"
                            name="postcode"
                            css="text--uppercase"
                            v-model="searchObject.postcode"
                            label="Postcode"
                            placeholder="E.g. M3 5ER"
                            :no-float="true"
                            @update="postcodeInput"
                    ></input-text>
                </div>
                <div class="col-6-md pt-10">
                    <drop-down
                            v-model="searchObject.range"
                            name="range"
                            :options="searchOptions.range"
                            @change="updateCount"
                            label="Range"
                    ></drop-down>
                </div>
                <div class="col-12-sm">
                    <div v-if="invalidPostcode" class="alert">
                        Oops this does not look like a valid postcode.
                    </div>
                    <div v-if="postcodeRequired" class="alert">
                        Please enter a postcode to sort by distance
                    </div>
                </div>
            </div>

            <template v-if="['used', 'finance'].includes(cars)">
                <div class="refine__header">
                    Mileage
                </div>
                <drop-down
                        v-model="searchObject.maxmileage"
                        name="maxmileage"
                        :options="searchOptions.maxmileage"
                        @change="updateCount"
                ></drop-down>

                <div class="row" v-if="hasYearRange">
                    <div class="col-12-sm">
                        <div class="refine__header">
                            Production Year
                        </div>
                    </div>
                    <div class="col-6-md">
                        <input-text
                                v-model="searchObject.minyear"
                                input-type="number"
                                name="minyear"
                                @update="updateCount"
                                label="From"
                        ></input-text>
                    </div>
                    <div class="col-6-md">
                        <input-text
                                v-model="searchObject.maxyear"
                                input-type="number"
                                name="maxyear"
                                @update="updateCount"
                                label="To"
                        ></input-text>
                    </div>
                    <div class="col-12-sm">
                        <div v-if="invalidYearRange" class="alert">
                            Oops, make sure the max year is higher than the min year
                        </div>
                    </div>
                </div>

                <div class="refine__header" v-if="!hasYearRange">
                    Age
                </div>
                <drop-down
                        v-if="!hasYearRange"
                        v-model="searchObject.maxage"
                        name="maxage"
                        :options="searchOptions.maxage"
                        @change="updateCount"
                ></drop-down>
            </template>

            <div class="form__input d-flex mb-20" style="align-items: center;justify-content: flex-start;">
                <div style="height: 30px;">
                    <slider
                        name="ulezexempt"
                        v-model="searchObject.ulezexempt"
                        @change="updateCount"
                        on-text="Yes"
                        off-text=""
                    ></slider>
                </div>
                <div style="margin-left: 10px;">
                    ULEZ Exempt
                </div>
            </div>

            <a href="#" v-if="!callCenterUser" class="d-block text-center text--underline mb-10"
                 @click.prevent="showMoreOptions"
                 v-html="moreOptionsVisible ? 'Less Options' : 'More Options'"></a>

            <div :class="{'refine__extras': true, hidden: !callCenterUser && !moreOptionsVisible}">
                <div v-show="cars === 'used'">
                    <div class="refine__header">
                        Colour
                    </div>
                    <drop-down
                            v-model="searchObject.colour"
                            name="colour"
                            :options="searchOptions.colour"
                            @change="updateCount"
                    ></drop-down>
                </div>

                <div class="refine__header">
                    Transmission
                </div>
                <drop-down
                        v-model="searchObject.transmission"
                        name="transmission"
                        :options="searchOptions.transmission"
                        @change="updateCount"
                ></drop-down>


                <div class="refine__header">
                    Engine Size
                </div>
                <drop-down
                        v-model="searchObject.litre"
                        name="litre"
                        :options="searchOptions.litre"
                        @change="updateCount"
                ></drop-down>


                <div class="refine__header">
                    MPG
                </div>
                <drop-down
                        v-model="searchObject.mpg"
                        name="mpg"
                        :options="searchOptions.mpg"
                        @change="updateCount"
                ></drop-down>


                <div class="refine__header">
                    Seats
                </div>
                <drop-down
                        v-model="searchObject.seats"
                        name="seats"
                        :options="searchOptions.seats"
                        @change="updateCount"
                ></drop-down>


                <div class="refine__header">
                    Doors
                </div>
                <drop-down
                        v-model="searchObject.doors"
                        name="doors"
                        :options="searchOptions.doors"
                        @change="updateCount"
                ></drop-down>


                <div class="refine__header">
                    Fuel Type
                </div>
                <drop-down
                        v-model="searchObject.fuel"
                        name="fuel"
                        :options="searchOptions.fuel"
                        @change="updateCount"
                ></drop-down>

                <div v-show="cars === 'used'">
                    <div class="refine__header">
                        Wheelbase
                    </div>
                    <drop-down
                        v-model="searchObject.wheelbase"
                        name="fuel"
                        :options="searchOptions.wheelbase"
                        @change="updateCount"
                    ></drop-down>
                </div>

                <div class="row">
                    <div class="col-12-sm">
                        <div class="refine__header">
                            Insurance group
                        </div>
                    </div>
                    <div class="col-6-md">
                        <drop-down
                                v-model="searchObject.mininsurance"
                                name="mininsurance"
                                :options="searchOptions.insurance"
                                @change="updateCount"
                                label="Minimum"
                        ></drop-down>
                    </div>
                    <div class="col-6-md">
                        <drop-down
                                v-model="searchObject.maxinsurance"
                                name="maxinsurance"
                                :options="searchOptions.insurance"
                                @change="updateCount"
                                label="Maximum"
                        ></drop-down>
                    </div>
                    <div class="col-12-sm">
                        <div v-if="invalidInsuranceGroupRange" class="alert">
                            Oops make sure you have a max insurance group higher than the min insurance group
                        </div>
                    </div>
                </div>

              <template v-if="cars === 'used'">
              <div class="form__input d-flex mb-20" style="align-items: center;justify-content: flex-start;">
                <div style="height: 30px;">
                  <slider
                    name="reserveonline"
                    v-model="searchObject.reserveonline"
                    @change="updateCount"
                    on-text="Yes"
                    off-text="No"
                  ></slider>
                </div>
                <div style="margin-left: 10px;">
                  Can reserve online
                </div>
              </div>

                <div class="form__input d-flex mb-20" style="align-items: center;justify-content: flex-start;">
                    <div style="height: 30px;">
                        <slider
                            name="independent"
                            v-model="searchObject.independent"
                            @change="updateCount"
                            on-text="Yes"
                            off-text="No"
                        ></slider>
                    </div>
                    <div style="margin-left: 10px;">
                        Independent dealers only
                    </div>
                </div>
              </template>

                <div class="refine__header">
                    Keyword
                </div>
                <keywords :keywords="searchObject.keywords" :use-get-vars="true" @update="updateKeywords">
                </keywords>
            </div>

            <div class="row">
                <div class="col-12-sm">
                    <button @click="searchResults" type="button" class="button button--full button--small mb-10"
                            :disabled="resultUpdating || resultCount === 0">
                        <template v-if="!resultUpdating">
                            See {{ formatThousandsWithRounding(resultCount) }} results <i
                                class="fi-right-open"></i>
                        </template>
                        <template v-else>
                            <i class="fi-spinner" style="margin-right: 10px;"></i> Searching vehicles...
                        </template>
                    </button>
                </div>
                <div class="col-12-sm">
                    <button @click="saveSearch" type="button"
                            class="button button--full button--small mb-10">
                        Save search
                    </button>
                </div>
                <div class="col-12-sm">
                    <button @click="clearOptions($event)" type="button"
                            class="button button--ghost button--full button--small mb-10">
                        Reset filters
                    </button>
                </div>
                <div class="col-12-sm text-center">
                    <a href="/garage#savedSearches">View saved searches</a> |
                    <a href="/garage/starred-vehicles">View saved vehicles</a>
                </div>
                <div class="col-12-sm" v-if="mobileRefineOpened">
                    <button @click.prevent="mobileRefineToggle" type="button"
                            class="button button--ghost button--full button--small mb-10">
                        <i class="fi-filter"></i> Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {titleCase} from '../../helpers/str-helpers';
import Keywords from './keywords.vue';
import MultiSelect from '../global/multi-select.vue';
import formatThousandsWithRounding from '../../modules/formatThousandsWithRounding';
import Slider from '../global/slider.vue';
import axiosClient from '../../modules/axiosClient';

type ModelDropdownOptions = {
    [key: string]: DropdownOptions
}

type CarType = 'used'|'new';
type PriceType = 'cash'|'finance';

type SelectedMakes = string[];
type SelectedModels = {
    [key: string]: string[]
}
type SelectedKeywords = string[];

type SearchConfig = {
    makes: SelectedMakes,
    models: SelectedModels,
    bodystyle: string,
    minprice: string,
    maxprice: string,
    minmonthly: string,
    maxmonthly: string,
    contractTerm: string,
    monthsUpfront: string,
    annualMileage: string,
    inStock: boolean,
    specialOffer: boolean,
    maintenanceincluded: boolean,
    pricetype: string,
    finance: string,
    region: string,
    city: string,
    postcode: string,
    range: string,
    maxmileage: string,
    minyear: string,
    maxyear: string,
    maxage: string,
    wheelbase: string,
    ulezexempt: boolean,
    colour: string,
    transmission: string,
    litre: string,
    mpg: string,
    seats: string,
    doors: string,
    fuel: string,
    mininsurance: string,
    maxinsurance: string,
    independent: boolean,
    reserveonline: boolean,
    keywords: SelectedKeywords,
}

export default defineComponent({
    props: [
        'single',
        'refineData',
        'initialMakes',
        'initialTotalResults',
        'sortBy',
        'offerType',
    ],
    components: {
        Keywords,
        Slider,
        MultiSelect,
    },
    data() {
        return {
            cars: this.offerType,

            callCenterUser: false,
            partner: 'regit',
            resultCount: 0,
            resultUpdating: false,
            makesUpdating: false,
            moreOptionsVisible: false,
            mobileRefineOpened: false,

            dealer: '',
            dealerId: '', // todo: deprecated
            dealerName: '',

            searchObject: {
                makes: [],
                models: {},
                bodystyle: '',
                minprice: '',
                maxprice: '',
                minmonthly: '',
                maxmonthly: '',
                contractTerm: '24',
                monthsUpfront: '3',
                annualMileage: '5000',
                inStock: false,
                specialOffer: false,
                maintenanceincluded: false,
                pricetype: '',
                finance: '',
                region: '',
                city: '',
                postcode: '',
                range: '',
                maxmileage: '',
                minyear: '',
                maxyear: '',
                maxage: '',
                wheelbase: '',
                ulezexempt: false,
                colour: '',
                transmission: '',
                litre: '',
                mpg: '',
                seats: '',
                doors: '',
                fuel: '',
                mininsurance: '',
                maxinsurance: '',
                independent: false,
                reserveonline: false,
                keywords: [],
            } as SearchConfig,
            searchOptions: {
                makes: [] as DropdownOptions,
                models: {} as ModelDropdownOptions,
                bodystyle: [
                    {value: '', text: 'Any bodystyle'},
                    {value: '4x4', text: '4x4'},
                    {value: 'convertible', text: 'Convertible'},
                    {value: 'coupe', text: 'Coupe'},
                    {value: 'estate', text: 'Estate'},
                    {value: 'hatchback', text: 'Hatchback'},
                    {value: 'mpv', text: 'MPV'},
                    {value: 'saloon', text: 'Saloon'},
                    {value: 'supermini', text: 'Supermini'},
                    {value: 'pickup', text: 'Pickup'},
                    {value: 'van', text: 'Van'},
                ] as DropdownOptions,
                price: [
                    {value: '', text: 'Any'},
                    {value: '1', text: '1'},
                    {value: '500', text: '500'},
                    {value: '1000', text: '1000'},
                    {value: '2000', text: '2000'},
                    {value: '3000', text: '3000'},
                    {value: '4000', text: '4000'},
                    {value: '5000', text: '5000'},
                    {value: '6000', text: '6000'},
                    {value: '7000', text: '7000'},
                    {value: '8000', text: '8000'},
                    {value: '9000', text: '9000'},
                    {value: '10000', text: '10,000'},
                    {value: '12500', text: '12,500'},
                    {value: '15000', text: '15,000'},
                    {value: '17500', text: '17,500'},
                    {value: '20000', text: '20,000'},
                    {value: '25000', text: '25,000'},
                    {value: '30000', text: '30,000'},
                    {value: '35000', text: '35,000'},
                    {value: '40000', text: '40,000'},
                    {value: '45000', text: '45,000'},
                    {value: '50000', text: '50,000'},
                    {value: '55000', text: '55,000'},
                    {value: '60000', text: '60,000'},
                    {value: '75000', text: '75,000'},
                    {value: '100000', text: '100,000'},
                    {value: '250000', text: '250,000'},
                    {value: '500000', text: '500,000'},
                    {value: '1000000', text: '1,000,000'},
                ] as DropdownOptions,
                monthlyPrice: [
                    {value: '', text: 'Any'},
                    {value: '1', text: '1'},
                    {value: '100', text: '100'},
                    {value: '125', text: '125'},
                    {value: '150', text: '150'},
                    {value: '175', text: '175'},
                    {value: '200', text: '200'},
                    {value: '250', text: '250'},
                    {value: '300', text: '300'},
                    {value: '350', text: '350'},
                    {value: '400', text: '400'},
                    {value: '450', text: '450'},
                    {value: '500', text: '500'},
                    {value: '550', text: '550'},
                    {value: '600', text: '600'},
                    {value: '700', text: '700'},
                    {value: '800', text: '800'},
                    {value: '900', text: '900'},
                    {value: '1000', text: '1000'},
                ] as DropdownOptions,
                contractTerm: [
                    {value: '24', text: '24 Months'},
                    {value: '36', text: '36 Months'},
                    {value: '48', text: '48 Months'},
                ] as DropdownOptions,
                monthsUpfront: [
                    {value: '3', text: '3 Months'},
                    {value: '6', text: '6 Months'},
                    {value: '9', text: '9 Months'},
                ],
                annualMileage: [
                    {value: '5000', text: '5000 Miles'},
                    {value: '10000', text: '10000 Miles'},
                    {value: '15000', text: '15000 Miles'},
                ],
                finance: [
                    {value: '', text: 'Any Finance Type'},
                    {value: 'business', text: 'Business Finance'},
                    {value: 'personal', text: 'Personal Finance'},
                ] as DropdownOptions,
                range: [
                    {value: '', text: 'National'},
                    {value: '1', text: '1 mile'},
                    {value: '2', text: '2 miles'},
                    {value: '5', text: '5 miles'},
                    {value: '10', text: '10 miles'},
                    {value: '20', text: '20 miles'},
                    {value: '30', text: '30 miles'},
                    {value: '40', text: '40 miles'},
                    {value: '50', text: '50 miles'},
                    {value: '60', text: '60 miles'},
                    {value: '75', text: '75 miles'},
                    {value: '100', text: '100 miles'},
                    {value: '150', text: '150 miles'},
                    {value: '200', text: '200 miles'},
                    {value: '300', text: '300 miles'},
                ] as DropdownOptions,
                maxmileage: [
                    {value: '', text: 'Any mileage'},
                    {value: '100', text: 'Up to 100 miles'},
                    {value: '1000', text: 'Up to 1000 miles'},
                    {value: '5000', text: 'Up to 5000 miles'},
                    {value: '10000', text: 'Up to 10,000 miles'},
                    {value: '20000', text: 'Up to 20,000 miles'},
                    {value: '30000', text: 'Up to 30,000 miles'},
                    {value: '40000', text: 'Up to 40,000 miles'},
                    {value: '50000', text: 'Up to 50,000 miles'},
                    {value: '60000', text: 'Up to 60,000 miles'},
                    {value: '70000', text: 'Up to 70,000 miles'},
                    {value: '80000', text: 'Up to 80,000 miles'},
                    {value: '90000', text: 'Up to 90,000 miles'},
                    {value: '100000', text: 'Up to 100,000 miles'},
                ] as DropdownOptions,
                maxage: [
                    {value: '', text: 'Any age'},
                    {value: '1', text: 'up to 1 year old'},
                    {value: '2', text: 'up to 2 year old'},
                    {value: '3', text: 'up to 3 year old'},
                    {value: '4', text: 'up to 4 year old'},
                    {value: '5', text: 'up to 5 year old'},
                    {value: '6', text: 'up to 6 year old'},
                    {value: '7', text: 'up to 7 year old'},
                    {value: '8', text: 'up to 8 year old'},
                    {value: '9', text: 'up to 9 year old'},
                    {value: '10', text: 'up to 10 year old'},
                    {value: '11', text: 'over 10 years old'},
                ] as DropdownOptions,
                wheelbase: [
                    {value: '', text: 'Any wheelbase'},
                    {value: '1', text: 'Short wheelbase'},
                    {value: '2', text: 'Medium wheelbase'},
                    {value: '3', text: 'Long wheelbase'},
                    {value: '4', text: 'Extra long wheelbase'},
                ] as DropdownOptions,
                colour: [
                    {value: '', text: 'Any colour'},
                    {value: 'black', text: 'Black'},
                    {value: 'blue', text: 'Blue'},
                    {value: 'green', text: 'Green'},
                    {value: 'grey', text: 'Grey'},
                    {value: 'other', text: 'Other'},
                    {value: 'red', text: 'Red'},
                    {value: 'white', text: 'White'},
                    {value: 'silver', text: 'Silver'},
                ] as DropdownOptions,
                transmission: [
                    {value: '', text: 'Any transmission'},
                    {value: 'semi automatic', text: 'Semi Automatic'},
                    {value: 'automatic', text: 'Automatic'},
                    {value: 'manual', text: 'Manual'},
                ] as DropdownOptions,
                litre: [
                    {value: '', text: 'Any engine size'},
                    {value: '1.2', text: '< 1.3'},
                    {value: '1.3-1.6', text: '1.3 - 1.6'},
                    {value: '1.7-1.9', text: '1.7 - 1.9'},
                    {value: '2.0-2.5', text: '2.0 - 2.5'},
                    {value: '2.6-2.9', text: '2.6 - 2.9'},
                    {value: '3.0-3.9', text: '3.0 - 3.9'},
                    {value: '4.0', text: '4.0 +'},
                ] as DropdownOptions,
                mpg: [
                    {value: '', text: 'Any MPG'},
                    {value: 'low', text: 'Less than 50 MPG'},
                    {value: 'average', text: '50-75 MPG'},
                    {value: 'high', text: 'More than 75 MPG'},
                    {value: 'top', text: 'More than 100 MPG'},
                ] as DropdownOptions,
                seats: [
                    {value: '', text: 'Any seats'},
                    {value: '2', text: '2 seats'},
                    {value: '3', text: '3 seats'},
                    {value: '4', text: '4 seats'},
                    {value: '5', text: '5 seats'},
                    {value: '6', text: '6 seats'},
                    {value: '7', text: '7 seats'},
                    {value: '8', text: '8 seats'},
                    {value: '9', text: '9 seats'},
                ] as DropdownOptions,
                doors: [
                    {value: '', text: 'Any doors'},
                    {value: '2', text: '2 door'},
                    {value: '3', text: '3 door'},
                    {value: '4', text: '4 door'},
                    {value: '5', text: '5 door'},
                    {value: '6', text: '6 door'},
                    {value: '7', text: '7 door'},
                ] as DropdownOptions,
                insurance: [
                    {value: '', text: 'Any groups'},
                    {value: '5', text: '5'},
                    {value: '10', text: '10'},
                    {value: '15', text: '15'},
                    {value: '20', text: '20'},
                    {value: '25', text: '25'},
                    {value: '30', text: '30'},
                    {value: '35', text: '35'},
                    {value: '40', text: '40'},
                    {value: '45', text: '45'},
                    {value: '50', text: '50'},
                ] as DropdownOptions,
                fuel: [
                    {value: '', text: 'Any fuel type'},
                    {value: 'hybrid', text: 'Hybrid'},
                    {value: 'petrol', text: 'Petrol'},
                    {value: 'electric', text: 'Electric'},
                    {value: 'diesel', text: 'Diesel'},
                    {value: 'other', text: 'Other'},
                ] as DropdownOptions,
            },
        };
    },
    methods: {
        changeCarType(value: CarType) {
            if (value === 'used') {
                this.cars = 'used';
            } else {
                this.cars = 'new';
            }

            this._resetMakesModels();

            this.dealer = '';
            this.dealerId = '';
            this.dealerName = '';

            this.updateCount();
        },
        changePriceType(priceType: PriceType) {
            this.searchObject = Object.assign({}, this.searchObject, {pricetype: priceType});
            this._resetMakesModels();
            this.updateCount();
        },
        removeDealerFilter() {
            this.dealer = '';
            this.dealerId = '';
            this.dealerName = '';

            this.updateCount();
        },
        removeRegionFilter() {
            this.searchObject.region = '';
            this.searchObject.city = '';

            this.updateCount();
        },
        _resetMakesModels() {
            this.searchObject.makes = [] as SelectedMakes;
            this.searchObject.models = {} as SelectedModels;

            if (this.cars === this.refineData.cars) {
                this.searchOptions.makes = this.convertToOptions(this.initialMakes);
            } else {
                this.searchOptions.makes = [];
                this.makesUpdating = true;
                axiosClient.get('/api/car-search/makes/' + this.cars).then((response) => {
                    this.searchOptions.makes = this.convertToOptions(response.data);
                    this.makesUpdating = false;
                }, (response) => {
                    console.log(response);
                    this.makesUpdating = false;
                });
            }
        },
        changeMake(makes: SelectedMakes) {
            makes.forEach((make) => {
                if (!(make in this.searchOptions.models)) {
                    this.searchOptions.models[make] = [];
                    this._populateMakeModels(make);
                }
            });

            this.updateCount();
        },
        _populateMakeModels(make: string) {
            axiosClient.get('/api/car-search/models/'+ this.cars + '/' + make).then((response) => {
                const newModelObj = {} as ModelDropdownOptions;
                newModelObj[make] = this.convertToOptions(response.data);
                const models = Object.assign({}, this.searchOptions.models, newModelObj);
                this.searchOptions = Object.assign({}, this.searchOptions, {models: models});
            }, (response) => {
                console.log(response);
            });
        },
        mobileRefineToggle() {
            this.mobileRefineOpened = !this.mobileRefineOpened;
            // this.scrollToStart();
        },
        postcodeInput() {
            this.updateCount();
        },
        showMoreOptions() {
            this.moreOptionsVisible = !this.moreOptionsVisible;
        },
        updateKeywords(keywords: SelectedKeywords) {
            this.searchObject.keywords = keywords;
            this.updateCount();
        },
        clearOptions() {
            this.searchObject = Object.assign({}, this.defaultSearchObject, {keywords: [] as SelectedKeywords});
            this.updateCount();
        },
        _hasRefineFromMoreOptions() {
            return this.refineData.colour ||
                this.refineData.transmission ||
                this.refineData.litre ||
                this.refineData.mpg ||
                this.refineData.seats ||
                this.refineData.doors ||
                this.refineData.fuel ||
                this.refineData.reserveonline ||
                this.refineData.keywords.length > 0;
        },


        // COUNT AND RESULTS
        _getUrl() {
            const typeOfCar = this.cars;
            const typeSegment = '/' + typeOfCar + '-cars';
            const makeSegment = this._getUrlMakeSegment();
            const querySegment = this._getUrlQuery();

            let apiUrl = typeSegment;

            if (makeSegment) {
                apiUrl += '/' + makeSegment;
            }

            if (querySegment) {
                apiUrl += '/' + querySegment;
            }

            apiUrl = apiUrl.toLowerCase();
            apiUrl = apiUrl.replace(/ /g, '-');

            if (this.searchObject.keywords.length > 0) {
                const comp = encodeURIComponent(this.searchObject.keywords.join(',')).replace(/%2C/g, ',');
                apiUrl += `?keywords=${comp}`;
            }

            return apiUrl.toLowerCase();
        },
        _getUrlMakeSegment() {
            const makes = this.searchObject.makes;
            const models = this.searchObject.models;

            if (makes.length > 0) {
                const makeModelParts = [] as string[];
                makes.forEach((make) => {
                    if (make in models && models[make].length > 0) {
                        models[make].forEach((model) => {
                            makeModelParts.push(make + '_' + model);
                        });
                    } else {
                        makeModelParts.push(make);
                    }
                });

                return makeModelParts.join('__');
            }

            return 'all';
        },
        _getUrlQuery() {
            const apiQueryParts = [];

            if (!this.isFieldEmpty(this.partner) && this.partner !== 'regit') {
                apiQueryParts.push('partner-' + this.partner);
            }

            if (!this.isFieldEmpty(this.searchObject.bodystyle)) {
                apiQueryParts.push('bodystyle-' + this.searchObject.bodystyle);
            }

            if (!this.isFieldEmpty(this.searchObject.minprice) && (['used', 'finance'].includes(this.cars) && this.searchObject.pricetype === 'cash')) {
                apiQueryParts.push('minprice-' + this.searchObject.minprice);
            }

            if (!this.isFieldEmpty(this.searchObject.maxprice) && (['used', 'finance'].includes(this.cars) && this.searchObject.pricetype === 'cash')) {
                apiQueryParts.push('maxprice-' + this.searchObject.maxprice);
            }

            if (!this.isFieldEmpty(this.searchObject.minmonthly) && (this.searchObject.pricetype === 'finance')) {
                apiQueryParts.push('minmonthly-' + this.searchObject.minmonthly);
            }

            if (!this.isFieldEmpty(this.searchObject.maxmonthly) && (this.searchObject.pricetype === 'finance')) {
                apiQueryParts.push('maxmonthly-' + this.searchObject.maxmonthly);
            }

            if (this.searchObject.inStock) {
                apiQueryParts.push('instock-' + this.searchObject.inStock);
            }

            if (this.searchObject.specialOffer) {
                apiQueryParts.push('specialoffer-' + this.searchObject.specialOffer);
            }

            if (!this.isFieldEmpty(this.searchObject.finance) && this.searchObject.pricetype === 'finance') {
                apiQueryParts.push('finance-' + this.searchObject.finance);
            }

            if (!this.isFieldEmpty(this.searchObject.pricetype)) {
                apiQueryParts.push('pricetype-' + this.searchObject.pricetype);
            }

            if (!this.isFieldEmpty(this.searchObject.region)) {
                apiQueryParts.push('region-' + this.searchObject.region);
            }

            if (!this.isFieldEmpty(this.searchObject.city)) {
                apiQueryParts.push('city-' + this.searchObject.city);
            }

            if (!this.isFieldEmpty(this.searchObject.postcode)) {
                let postcode = this.searchObject.postcode;
                postcode = postcode.replace(/ /g, '');
                apiQueryParts.push('postcode-' + postcode);
            }

            if (!this.isFieldEmpty(this.searchObject.range)) {
                apiQueryParts.push('range-' + this.searchObject.range);
            }

            if (!this.isFieldEmpty(this.searchObject.minyear) && this.cars === 'used') {
                apiQueryParts.push('minyear-' + this.searchObject.minyear);
            }

            if (!this.isFieldEmpty(this.searchObject.maxyear) && this.cars === 'used') {
                apiQueryParts.push('maxyear-' + this.searchObject.maxyear);
            }

            if (!this.isFieldEmpty(this.searchObject.maxage) && this.cars === 'used') {
                apiQueryParts.push('maxage-' + this.searchObject.maxage);
            }

            if (!this.isFieldEmpty(this.searchObject.wheelbase) && this.cars === 'used') {
                apiQueryParts.push('wheelbase-' + this.searchObject.wheelbase);
            }

            if (!this.isFieldEmpty(this.searchObject.maxmileage) && this.cars === 'used') {
                apiQueryParts.push('maxmileage-' + this.searchObject.maxmileage);
            }

            if (!this.isFieldEmpty(this.searchObject.colour)) {
                apiQueryParts.push('colour-' + this.searchObject.colour);
            }

            if (!this.isFieldEmpty(this.searchObject.transmission)) {
                apiQueryParts.push('transmission-' + this.searchObject.transmission.replace(' ', '-'));
            }

            if (!this.isFieldEmpty(this.searchObject.litre)) {
                apiQueryParts.push('litre-' + this.searchObject.litre);
            }

            if (!this.isFieldEmpty(this.searchObject.fuel)) {
                apiQueryParts.push('fuel-' + this.searchObject.fuel);
            }

            if (!this.isFieldEmpty(this.searchObject.mpg)) {
                apiQueryParts.push('mpg-' + this.searchObject.mpg);
            }

            if (!this.isFieldEmpty(this.searchObject.seats)) {
                apiQueryParts.push('seats-' + this.searchObject.seats);
            }

            if (!this.isFieldEmpty(this.searchObject.doors)) {
                apiQueryParts.push('doors-' + this.searchObject.doors);
            }

            if (!this.isFieldEmpty(this.searchObject.mininsurance)) {
                apiQueryParts.push('mininsurance-' + this.searchObject.mininsurance);
            }

            if (!this.isFieldEmpty(this.searchObject.maxinsurance)) {
                apiQueryParts.push('maxinsurance-' + this.searchObject.maxinsurance);
            }

            if (this.searchObject.ulezexempt) {
                apiQueryParts.push('ulezexempt-' + this.searchObject.ulezexempt);
            }

            if (this.searchObject.independent) {
                apiQueryParts.push('independent-1');
            }

            if (this.searchObject.reserveonline) {
                apiQueryParts.push('reserveonline-1');
            }

            // todo: deprecated
            if (!this.isFieldEmpty(this.dealerId)) {
                apiQueryParts.push('dealerid-' + this.dealerId);
            }

            if (!this.isFieldEmpty(this.dealer)) {
                apiQueryParts.push('dealer-' + this.dealer);
            }

            return apiQueryParts.join('_');
        },
        updateCount() {
            // refresh object, so all computed props are updated
            this.searchObject = Object.assign({}, this.searchObject);

            if (this.invalidPostcode || this.invalidPriceRange) {
                this.resultCount = 0;
                return;
            }

            const url = this._getUrl();
            console.log('Updating counts from: ', url);
            this.resultUpdating = true;

            axiosClient.get('/api/car-search/count' + url).then((response) => {
                this.resultCount = response.data.totalRows || 0;
                this.resultUpdating = false;
            }, (response) => {
                console.log(response);
                this.resultCount = 0;
                this.resultUpdating = false;
            });
        },
        _getAdTargeting() {
            const makes = this.searchObject.makes;
            const lastMake = makes[makes.length - 1];
            const models = this.searchObject.models[lastMake] || [];
            const lastModel = models[models.length - 1];

            return {
                make: lastMake || '',
                model: lastModel || '',
                body: (this.searchObject.bodystyle !== '') ? this.searchObject.bodystyle : '',
            };
        },
        _getTotalPages() {
            return Math.ceil(this.resultCount / 10);
        },
        saveSearch() {
            const url = this._getUrl();

            axiosClient.post('/api/saved-searches', {
                searchString: url,
            }).then(() => {
                console.log('Search saved');
            }, () => {
                console.log('Search save error');
            });
        },
        searchResults() {
            if (this.mobileRefineOpened) {
                this.mobileRefineToggle();
            }
            this.$emit('navigate', {
                url: this._getUrl(),
                totalPages: this._getTotalPages(),
                totalResults: this.resultCount,
                adTargeting: this._getAdTargeting(),
                offerType: this.cars,
                priceType: this.searchObject.pricetype,
            });
        },


        // HELPERS
        isFieldEmpty(value: string|null|undefined) {
            return ['', null, undefined].indexOf(value) > -1;
        },
        formatThousandsWithRounding,
        convertToOptions(list: {[key: string]: string}): DropdownOptions {
            const result = Object.keys(list).map((key) => {
                return {
                    'value': key,
                    'text': list[key],
                };
            });

            return result.sort(function(x, y) {
                if (x.text < y.text) {
                    return -1;
                }
                if (x.text > y.text) {
                    return 1;
                }
                return 0;
            });
        },
    },
    computed: {
        invalidPriceRange(): boolean {
            let minPrice = parseInt(this.searchObject.minprice);
            let maxPrice = parseInt(this.searchObject.maxprice);

            if (this.searchObject.pricetype === 'finance') {
                minPrice = parseInt(this.searchObject.minmonthly);
                maxPrice = parseInt(this.searchObject.maxmonthly);
            }

            return (minPrice > maxPrice && maxPrice >= 0);
        },
        hasYearRange(): boolean {
            return this.searchObject.minyear !== '' || this.searchObject.maxyear !== '';
        },
        invalidYearRange(): boolean {
            const minYear = parseInt(this.searchObject.minyear);
            const maxYear = parseInt(this.searchObject.maxyear);

            return minYear > 0 && maxYear > 0 && minYear > maxYear;
        },
        invalidInsuranceGroupRange(): boolean {
            const minInsurance = parseInt(this.searchObject.mininsurance);
            const maxInsurance = parseInt(this.searchObject.maxinsurance);

            return (minInsurance > maxInsurance && maxInsurance >= 0);
        },
        invalidPostcode(): boolean {
            const postcodeRegEx = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/i;

            if (!this.searchObject.postcode) {
                return false;
            }

            return !postcodeRegEx.test(this.searchObject.postcode);
        },
        postcodeRequired(): boolean {
            return !this.searchObject.postcode && this.sortBy === 'distance';
        },
        defaultSearchObject(): SearchConfig {
            const defaultPriceType = 'cash';

            return {
                makes: [] as SelectedMakes,
                models: {} as SelectedModels,
                bodystyle: '',
                minprice: '',
                maxprice: '',
                minmonthly: '',
                maxmonthly: '',
                contractTerm: '48',
                monthsUpfront: '9',
                annualMileage: '5000',
                inStock: false,
                specialOffer: false,
                maintenanceincluded: false,
                pricetype: defaultPriceType,
                finance: '',
                region: '',
                city: '',
                postcode: '',
                range: '',
                maxmileage: '',
                minyear: '',
                maxyear: '',
                maxage: '',
                wheelbase: '',
                ulezexempt: false,
                colour: '',
                transmission: '',
                litre: '',
                mpg: '',
                seats: '',
                doors: '',
                fuel: '',
                mininsurance: '',
                maxinsurance: '',
                independent: false,
                reserveonline: false,
                keywords: [] as SelectedKeywords,
            };
        },
        localFilterLabel(): string {
            const value = this.searchObject.region || this.searchObject.city || '';
            value.replace(/-/g, ' ');

            return titleCase(value);
        },
    },

    mounted() {
        const makes = (this.refineData.makes || []) as SelectedMakes;

        // init makes and models options.
        this.searchOptions.makes = this.convertToOptions(this.initialMakes);
        makes.forEach((item) => this._populateMakeModels(item));

        this.searchObject = Object.assign({}, this.defaultSearchObject, this.refineData);
        this.cars = this.refineData.cars;
        this.partner = this.refineData.partner;

        this.moreOptionsVisible = this._hasRefineFromMoreOptions();
        this.resultCount = this.initialTotalResults || 0;
        this.dealer = this.refineData.dealer || '';
        this.dealerId = this.refineData.dealerid || '';
        this.dealerName = this.refineData.dealerName || '';

        this.searchObject.maintenanceincluded = this.refineData.maintenanceincluded === 'true';
        this.searchObject.reserveonline = this.refineData.reserveonline === '1';

        this.$emit('loaded', {
            url: this._getUrl(),
        });
    },
});
</script>
